(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kds-fashion-hero"] && !Shopify.designMode) return;
  try {
    
  class KdsFashionHero extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.ring = this.querySelector('[data-kfh-ring]');
      this.prevBtn = this.querySelector('[data-kfh-prev]');
      this.nextBtn = this.querySelector('[data-kfh-next]');

      this.reveal();
      if (this.ring) this.bindWheel();
    }

    /* Stagger index + entrance reveal via IntersectionObserver */
    reveal() {
      this.querySelectorAll('[data-kfh-stagger]').forEach((el, i) => {
        el.style.setProperty('--kfh-i', i);
      });

      const show = () => this.classList.add('kfh--revealed');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) { show(); return; }

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { show(); io.disconnect(); }
        });
      }, { threshold: 0.15 });
      io.observe(this);
    }

    /* Read the ring's current rotation from its computed matrix */
    currentAngle() {
      const t = getComputedStyle(this.ring).transform;
      if (!t || t === 'none') return 0;
      const m = t.match(/matrix\(([^)]+)\)/);
      if (!m) return 0;
      const v = m[1].split(',').map(parseFloat);
      return Math.atan2(v[1], v[0]) * 180 / Math.PI;
    }

    /* Freeze the CSS spin where it is, then hand control to the buttons */
    goManual() {
      if (this._manual) return;
      this._angle = this.currentAngle();
      this.ring.style.animation = 'none';
      this.ring.style.transform = 'rotate(' + this._angle + 'deg)';
      void this.ring.offsetWidth; /* reflow so the next change transitions */
      this.ring.style.transition = 'transform .9s cubic-bezier(.22,1,.36,1)';
      this._manual = true;
    }

    rotateBy(delta) {
      this.goManual();
      this._angle += delta;
      this.ring.style.transform = 'rotate(' + this._angle + 'deg)';
    }

    bindWheel() {
      const count = parseInt(this.ring.style.getPropertyValue('--kfh-count'), 10) || this.ring.children.length || 1;
      const step = 360 / count;
      /* Next continues the clockwise motion; previous reverses it */
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.rotateBy(step));
      this.prevBtn && this.prevBtn.addEventListener('click', () => this.rotateBy(-step));
    }

    disconnectedCallback() {}
  }

  if (!customElements.get('kds-fashion-hero')) {
    customElements.define('kds-fashion-hero', KdsFashionHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
